module.exports = __webpack_public_path__ + "img/45.9a96789a.png";